module.exports = "/_next/static/images/PersonalizeOnEveryChannel@2x-1779cf51ada149e6d43cf7fecc9a2083.webp";